export default function scrollToHash() {
  if (window.location.hash) {
    $('html, body').animate({
      scrollTop: $(window.location.hash).offset().top + 'px'
    }, 900, 'swing');
  }
}



//////////////////
// WEBPACK FOOTER
// ./js/2020/_scrollToHash.js
// module id = 4
// module chunks = 0